<eff-popup-header
    [title]="title"
    [dialogRef]="dialogRef"
    data-uiid="new-eff-add-documents-popup-header"
></eff-popup-header>
<div class="dialog-body" data-uiid="new-eff-add-documents-popup-dialog">
    @if (documents.length > 0) {
        <div class="d-flex flex-column">
            <div class="documents-container d-flex flex-column">
                @for (document of documents; track document) {
                    <div
                        class="document-container d-flex flex-row justify-content-between align-items-center"
                        data-uiid="new-eff-add-documents-popup-document-list"
                    >
                        <div class="d-flex flex-row gap-2 align-items-center document">
                            <eff-icon icon="description_outlined"></eff-icon>
                            <div>{{ document.Name }}</div>
                        </div>
                        @if (showDeleteButton() && document.CanDelete) {
                            <eff-button-with-confirmation
                                [label]="'controls.effAddDocumentsPopup.delete' | transloco"
                                icon="delete_outlined"
                                (onConfirmation)="onDelete(document)"
                            >
                            </eff-button-with-confirmation>
                        }
                    </div>
                }
            </div>
            <div class="controllers d-flex flex-column">
                @if (documentTypes) {
                    <div class="d-flex flex-column controller-container">
                        <div class="controller-label">{{ 'controls.effAddDocumentsPopup.documentType' | transloco }}</div>
                        <eff-select
                            class="document-type-controller"
                            [options]="documentTypes"
                            [formController]="docTypeFormControl"
                            data-uiid="new-eff-add-documents-popup-document-type-select"
                        ></eff-select>
                    </div>
                }
                <div class="d-flex flex-column controller-container">
                    <div class="controller-label">{{ 'controls.effAddDocumentsPopup.description' | transloco }}</div>
                    <eff-textarea
                        [formController]="docDescriptionFormControl"
                        [popupEnabled]="false"
                        data-uiid="new-eff-add-documents-popup-description-text-area"
                    ></eff-textarea>
                </div>
            </div>
        </div>
    }
</div>

<div class="dialog-footer">
    @if (showSaveButton) {
        <eff-button
            class="green"
            [text]="addDocumentBtnLabel"
            (click)="onApplyChanges()"
            data-uiid="new-eff-add-documents-popup-apply-button"
        ></eff-button>
    }
</div>
